import { React, useContext, useState } from "react";
import { useNavigate } from "react-router-dom"
import { Card } from 'antd-mobile';
import { RightOutline } from 'antd-mobile-icons'
import { UserContext } from 'utils/getContext'
import { headerBackground } from "utils/getImg";
import { BpmTabBar } from "components/TabBar/BpmTabBar";
import { eventPlan } from "utils/getImg";
import { BpmLoginCardContent } from "components/HomeLoginCardContent/BpmLoginCardContent"
import { HotServiceCard } from "./HotServiceCard"
import { ServiceArea } from "./ServiceArea"
import { AnnouncementModal } from './announcementModal'
import { page } from "utils/constant";
import 'static/css/home.css'

/**  首页 */
export function Home() {

  const [show, setShow] = useState(false)
  const navigate = useNavigate()
  const { userInfo, loginInfo } = useContext(UserContext)
  /** 点击登录箭头：跳转到 企业/个人 选择登录页 */
  function handleLoginClick() {
    const { loginUrl, requestParams, appLoginReturnUrl } = loginInfo || {}
    const login = `${loginUrl}${requestParams}&${appLoginReturnUrl}`
    if (login) {
      // window.location.href = encodeURI(login)
      window.location.href = login
    }
    // const baseUrl = window.location.origin;
    // window.location.href = baseUrl + '/hrss/getOpenId'

    // window.location.href = 'http://27.151.72.171:15512/hrss/getOpenId'
  }

  /** 点击更多服务：跳转到服务页 */
  function handleServicesClick() {
    navigate('/service', { state: { defaultActiveKey: ['1', '2', '3', '4'] } })
  }

  /** 查看办件进度 */
  function handleEventPlanButClick() {
    navigate(`/${page?.MINE}`)
  }


  return (
    <>
      <AnnouncementModal
        show={show}
        setShow={setShow}
      />
      <div className="background">
        <img className="headerImg" src={headerBackground} alt="背景"></img>
        <div className="backgroundContent">
          <Card className="headerCard">
            {/* 登录注册卡片 */}
            <BpmLoginCardContent userInfo={userInfo} />
            {
              !userInfo &&
              <div className="loginArrow" onClick={handleLoginClick}>
                <RightOutline fontSize={15} />
              </div>
            }
          </Card>
          <div className="contentWrap">
            <div className="cannotClick" onClick={() => setShow(true)}>
              <div className="homeTitle">服务专区</div>
              {/* 服务专区 */}
              <ServiceArea />
              <div className="homeTitle">我的办件</div>
              <div className="eventPlanContent">
                <img className="eventPlanBack" src={eventPlan} alt="办件进度" ></img>
                <div className="eventPlan">
                  <span>我的办件进度</span>
                  <button className="eventPlanBut" onClick={handleEventPlanButClick}>
                    立即查看 &gt;
                  </button>
                </div>
              </div>
              <div className="title">
                <span className="homeTitle">热门服务</span>
                <span className="services" onClick={handleServicesClick}>
                  更多服务
                  <RightOutline className="serArrows" fontSize={14} />
                </span>
              </div>
              {/* 热门服务 */}
              <HotServiceCard />
            </div>
            <div className="homeTitle">服务机构</div>
            {/* 服务专区 */}
            <ServiceArea type="org" />
          </div>
        </div>
      </div >
      {/* 底部导航栏 */}
      <BpmTabBar />
    </>
  )
}